import React from "react";

const BlogSidebarContent = ({ children, title, overflow, customStyle, wrapperClass }) => {
  return (
    <div className="xl:w-[340px] w-full shadow-[0px_5px_25px_rgba(79,105,139,.09)] h-auto bg-[#222] rounded-xl flex flex-col items-center justify-center">
      {/* title */}
      <div className="w-full relative flex justify-between items-center text-lg pl-5 mt-5 mb-3">
        <div className="flex items-center gap-2 px-4">
        <span className="block w-5 h-2 rounded-full bg-yellow-700 shadow-md"></span>
          <h1 className="text-gray-200 font-black">{title}</h1>
        </div>

        {/* <div className="flex flex-col gap-1">
          <span className="block bg-yellow-700 w-4 h-1 rounded-xl"></span>
          <span className="block bg-blue-300 w-7 h-1 rounded-xl"></span>
        </div> */}
      </div>
      {/* content */}
      <div className={`${wrapperClass} max-h-[375px] w-full p-4`}>
        <div
          className={`${
            customStyle ? customStyle : ""
          } sidebar-content w-full h-full flex flex-col gap-3 ${
            overflow ? "overflow-y-auto pl-3" : ""
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default BlogSidebarContent;
